// extracted by mini-css-extract-plugin
module.exports = {"lds-ellipsis":"style_lds-ellipsis__2BX-Z","lds-ellipsis1":"style_lds-ellipsis1__38Rv-","lds-ellipsis2":"style_lds-ellipsis2__3kwzy","lds-ellipsis3":"style_lds-ellipsis3__v7AD8"};